<template>
<footer>
	<div class="socials">
		<div class="text">Join us on social media</div>
		<div class="social-logos">
			<a href="https://www.facebook.com/DungeonFog"><i class="icon icon_social_facebook"></i></a>
			<a href="https://twitter.com/DungeonFog"><i class="icon icon_social_twitter"></i></a>
			<a href="https://discordapp.com/invite/Ewtsk7g"><i class="icon icon_social_discord"></i></a>
			<a href="https://www.reddit.com/r/DungeonFog/"><i class="icon icon_social_reddit"></i></a>
		</div>
	</div>
	<div class="links">
		<a href="https://www.dungeonfog.com/imprint">Imprint</a>
		<a href="https://www.dungeonfog.com/privacy-policy">Privacy Policy</a>
		<a href="https://www.dungeonfog.com/support/">Helpdesk</a>
		<a href="https://www.dungeonfog.com/deios/feedback/">Feedback Form</a>
		<!-- <a href="mailto:support@dungeonfog.com">Support</a> -->
	</div>
	<div class="copyright">
		&copy; Dungeonfog 2024
	</div>
</footer>
</template>

<script>
export default {
	name: 'FooterTemplate'
}
</script>
